//manage-profile.js
import React, { useEffect, useRef, useState } from 'react';
import { isAuthenticated } from '../../../auth';
import flatpickr from 'flatpickr';
import Toast from '../../../lib/toast';
import { getAllProfileByUser, updateUserLookup, updateUserProfile } from '../helper/api';
// import config from '../../../config';
import client from '../../../clients';
import { getRoles } from '../../../core/helper/RoleAPiCall';
import SearchFilter from '../../../components/search-filter';
import { getAllBranches } from '../../gyms/helper/api';
import { formatDateTime } from '../../../lib/utils';
import '../style.scss';

const ManageProfile = (props) => {

  const {user, token} = isAuthenticated();
  const [roles, setRoles] = useState([]);
  const birthDateRef = useRef(null);
  const anniversaryDateRef = useRef(null);
  const [isButtonLock, setButtonLock] = useState(true);
  const [currentElementId, setCurrentElementId] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [currentDropDownType, setCurrentDropDownType] = useState("");
  const [selectedProfileIndex, setSelectedProfileIndex] = useState(-1);

  const [updatedUserInfo, setUpdatedUserInfo] = useState({
    profileID:"",
    userId: "",
    email: "",
    mobile: "",
    password: "",
    // passwordConfirmation: "",
    firstName: "",
    middleName: "",
    lastName: "",
    gender: "",
    dob: "",
    maritalStatus: "",
    anniversaryDate: "",
  });

  const [userProfileImage, setProfileImage] = useState("");
  const [userGymProfiles, setUserGymProfiles] = useState([]);
  const [isAddNewProfileSectionOpen, setAddNewProfileSectionOpen] = useState(false);

  const [selectedGym, setSelectedGym] = useState("");
  const [selectedRoles, setSelectedRoles] = useState([]);


  // START - Select Gym
  const [isGymListOpen, setGymListOpen] = useState(false);
  const [searchingData, setSearchingData] = useState("");
  const [isBranchSpinnerLoader,setBranchSpinnerLoader] = useState(false);
  const [gymList, setGymList] = useState([]);
  const isInitialLoadComplete = useRef(false);
  const [totalGyms, setTotalGyms] = useState(0);
  var [gymPageCount,setGymPageCount] = useState(1);
  var [gymPageNo,setGymPageNo] = useState(1);
  var gymPageSize = 14;

  const getBranchParams = () => {
    let params = {
      gymPageNo,
      isFilterByProfile:true,
      pageSize:gymPageSize
    };
    if (searchingData) params.q = searchingData;
    // params.activationStatus = isBranchActive ? "active" : "inactive";
    return params;
  }

  const GetAllBranches = async (isReload) => {
    try {
      let param = getBranchParams();
      let gyms = await getAllBranches(user._id, token, param);
      if(!isInitialLoadComplete.current) isInitialLoadComplete.current = true;
      setGymList(isReload?gyms:[...gymList,...gyms]);
    } catch (error) {
    }
  }
  

  const handleSearchingData = (searchingData) => {
    setSearchingData(searchingData);
  }

  const toggleGymList = () => {
    setGymListOpen(!isGymListOpen);
  }

  const handleGymScroll = async event => {
    try {
      const { scrollTop, clientHeight, scrollHeight } = event.target;
      if ((scrollTop > 0) && ((Math.ceil((scrollTop + clientHeight)) >= scrollHeight)) && gymPageNo < gymPageCount && !isBranchSpinnerLoader) {
        setBranchSpinnerLoader(true)
        gymPageNo = gymPageNo + 1;
        setGymPageNo(gymPageNo);
        await GetAllBranches();
        setBranchSpinnerLoader(false)
      }
    } catch (error) {
      setBranchSpinnerLoader(false)
    }
  }

  const handleSelectGym = (gym) => {
    setSelectedGym(gym);
    setGymListOpen(false);
  }

  // END - Select Gym


  const handleAddNewProfileSectionOpen = () => {
    setAddNewProfileSectionOpen(!isAddNewProfileSectionOpen)
  }


  const toggleInputFields = (id, index) => event => {
    setCurrentElementId(id);
    if (event) {
      let interval = setInterval(() => {
        let element = event.target.querySelector('input');
        if (element) {
            element.focus();
            clearInterval(interval)
        }
      }, 0);
    }

    if(id == "selected-roles"){
      if(currentDropDownType !== id){
        setCurrentDropDownType(id);
      }else{
        setCurrentDropDownType("");
      }
    }

    if(id == "roles"){
      if(currentDropDownType !== id){
        setCurrentDropDownType(id);
      }else{
        setCurrentDropDownType("");
      }

      if(selectedProfileIndex == -1){
        setSelectedProfileIndex(index)
      }else{
        setSelectedProfileIndex(-1)
      }
    }
  }


  const handleChange = (event) => {
    
    if(currentElementId == "first-name"){
      setUpdatedUserInfo(prev => ({
        ...prev,
        firstName: event.target.value
      }));
    }

    if(currentElementId == "middle-name"){
      setUpdatedUserInfo(prev => ({
        ...prev,
        middleName: event.target.value
      }));
    }

    if(currentElementId == "last-name"){
      setUpdatedUserInfo(prev => ({
        ...prev,
        lastName: event.target.value
      }));
    }

    if(currentElementId == "mobile-number"){
      setUpdatedUserInfo(prev => ({
        ...prev,
        mobile: event.target.value
      }));
    }

    if(currentElementId == "email-address"){
      setUpdatedUserInfo(prev => ({
        ...prev,
        email: event.target.value
      }));
    }

    if(currentElementId == "password"){
      setUpdatedUserInfo(prev => ({
        ...prev,
        password: event.target.value
      }));
    }

    // if(currentElementId == "password-confirmation"){
    //   setUpdatedUserInfo(prev => ({
    //     ...prev,
    //     passwordConfirmation: event.target.value
    //   }));
    // }
  }


  const handleRadioAction = (type, value) => {
    if(type == "gender"){
      setUpdatedUserInfo(prev => ({
        ...prev,
        gender: value
      }))
    }

    if(type == "marital-status"){
      setUpdatedUserInfo(prev => ({
        ...prev,
        maritalStatus: value
      }))
    }
  }

  const handleChangeImage = (event) => {
    const file = event.target.files[0];

    if(file){
      setProfileImage(file)
    }
  }

  const getAllProfilesByUser = async (userId) => {
    try{
      if(userId){

        let params = {
          userId: userId,
          sortBy:'min-role',
          noLimit: true
        }

        const response = await getAllProfileByUser(user._id, token, params);

        console.log(response);

        if(!response.error){
          setUserGymProfiles(response)
        }else{
          new Toast({
            type:"error",
            duration:3000,
            message: response.error
          }) 
        }
      }
    }catch(err){
      new Toast({
        type:"error",
        duration:3000,
        message: err
      })
    }
  }

  const handleSaveUserInfo = async() => {
    try{
      const params = {
        // profileID: updatedUserInfo.profileID,
        userId: updatedUserInfo.userId,
        email: updatedUserInfo.email,
        mobile: updatedUserInfo.mobile,
        password: updatedUserInfo.password,
        // passwordConfirmation: updatedUserInfo.passwordConfirmation,
        firstName: updatedUserInfo.firstName,
        middleName: updatedUserInfo.middleName,
        lastName: updatedUserInfo.lastName,
        gender: updatedUserInfo.gender,
        dob: updatedUserInfo.dob,
        maritalStatus: updatedUserInfo.maritalStatus,
        anniversaryDate: updatedUserInfo.anniversaryDate
      }

      if(userGymProfiles){
        params.userGymProfiles = userGymProfiles
      }

      console.log(params)

      const response = await updateUserLookup(user._id, token, params);
      
      console.log(response)

      if(!response.error){
        new Toast({
          type:"success",
          duration:3000,
          message: "User Profile Updated SuccessFully"
        })

        if(userProfileImage != ""){

          let formData = new FormData();
          formData.append("userId", updatedUserInfo.userId);
          formData.append("photo", userProfileImage);

          const profileUpdateResponse = await updateUserProfile(user._id, token, formData);

          if(!profileUpdateResponse.error){
            new Toast({
              type:"success",
              duration:3000,
              message: "Profile Picture Updated SuccessFully"
            })
          }else{
            new Toast({
              type:"error",
              duration:3000,
              message: "Couldn't Update Profile Picture"
            })
          }
        }

        props.getUsers();
        
        props.toggleWorkoutPlanner();

      }else{
        new Toast({
          type:"error",
          duration:3000,
          message: response.error
        })
      }

    }catch(err){
      new Toast({
        type:"error",
        duration:3000,
        message: err
      })
    }
  }

  const handleRemoveRole = (index, subIndex) => {
    setUserGymProfiles(prev =>
      prev.map((user, i) => {
        if (i !== index) return user;

        return {
          ...user,
          roles: user.roles.filter((_, idx) => idx !== subIndex),
          rolelist: user.rolelist.filter((_, idx) => idx !== subIndex),
          minRole: Math.min(
            ...user.roles.filter((_, idx) => idx !== subIndex)
          )
        };
      })
    );
  };

  const handleAssignRole = (role, index) => {
    setUserGymProfiles((prev) =>
      prev.map((user, i) =>
        i === index
          ? {
              ...user,
              roles: [...user.roles, role.role],
              rolelist: [...user.rolelist, role]
            }
          : user
      )
    );
  };

  const handleRemoveSelectedRole = (index) => {
    setSelectedRoles((prev) => prev.filter((_,i) => i != index) )
  }

  const handleAssignSelectedRole = (role) => {
    setSelectedRoles((prev) => [...prev, role]);
  }

  const handleAddNewProfile = () => {
    console.log("1", selectedRoles, "2", selectedGym, "3", userGymProfiles)

    const baseProfile = userGymProfiles[0] || {};

    const newProfile = {
      userInfo: baseProfile.userInfo || {
        name: selectedUser.name,
        phone: selectedUser.phone,
        email: selectedUser.email,
      },

      isWpAdmin: baseProfile.isWpAdmin || false,

      roles: selectedRoles.map(r => r.role),

      status: baseProfile.status || "N.A",
      active: baseProfile.active ?? true,

      userId: baseProfile.userId || selectedUser._id,
      gymId:  selectedGym.gymId,
      branchId: selectedGym._id,

      deletedBy: null,

      rolelist: selectedRoles,

      branchName: selectedGym.name,
      branchAddress: selectedGym.address,

      minRole: Math.min(...selectedRoles.map(r => r.role)),
    };

    userGymProfiles.push(newProfile);
    setAddNewProfileSectionOpen(false)
  }

  const handleDeleteGymProfile = (userProfile) => {
    setUserGymProfiles(prev =>
      prev.filter(user => user.branchId !== userProfile.branchId)
    );
  }
 
  useEffect(async () => {
    
    const birthdayPicker = flatpickr(birthDateRef.current, {
      disableMobile: true,
      dateFormat: "Y-m-d",
      onChange: ([date]) => {
        const istDate = date.toLocaleDateString('en-CA', {
          timeZone: 'Asia/Kolkata'
        });
        setUpdatedUserInfo(prev => ({
          ...prev,
          dob: istDate
        }));
      }
    });

   const anniversaryDate = flatpickr(anniversaryDateRef.current, {
  disableMobile: true,
  dateFormat: "Y-m-d",
  onChange: ([date]) => {
    const istDate = date.toLocaleDateString('en-CA', {
      timeZone: 'Asia/Kolkata'
    });
    setUpdatedUserInfo(prev => ({
      ...prev,
      anniversaryDate: istDate   
    }))
  }
  })
  
    return () => {
      birthdayPicker.destroy();
      anniversaryDate.destroy();
    }
  }, []);


  useEffect(() => {
    console.log(props.user)
    setSelectedUser(props.user);
  },[props.user])


  useEffect(() => {
    if (selectedUser) {
      console.log(selectedUser);

      getAllProfilesByUser(selectedUser._id);
      // const nameParts = (selectedUser.name || "").trim().split(/\s+/);

      setUpdatedUserInfo({
        profileID: selectedUser.profileID || "",
        userId: selectedUser._id || "",
        email: selectedUser.email || "",
        mobile: selectedUser.phone || "",
        password: "",
        // passwordConfirmation: "",
        firstName: (selectedUser.first_name ? selectedUser.first_name : selectedUser.name ? selectedUser.name : ""),
        middleName: selectedUser.middle_name ||  "",
        lastName: selectedUser.last_name || "",
        gender: selectedUser.gender || "",
        dob: selectedUser.dob || "",
        maritalStatus: selectedUser.maritalStatus || "",
        anniversaryDate: selectedUser.anniversaryDate || "",
      });
    }
  }, [selectedUser]);


  useEffect(async() => {
    try{
      const roles = await getRoles(user._id,token);
      // filter(role=>role.name != "member" && role.name != "workoutplus-admin")
      if(!roles.error) setRoles(roles);

      GetAllBranches(true);
    }catch(error){

    }
  },[searchingData])

  const isMobile = window.innerWidth < 768;

  return(
    <div className={isMobile ? "w-full h-full" : "global-modal-container d-flex"}>
      <div className={isMobile ? "w-full h-full mp-modal--mobile" : "global-modal-type-2 planner-assign-modal flex-item"} style={!isMobile ? {padding:"0", width:"70%", height:"80vh"} : undefined}>
        {
          window.innerWidth > 767 && (
            <div className="d-flex w-full space-between" style={{background: "var(--darkBlue)", padding:"12px", borderRadius: "14px 14px 0 0"}}>
              <div className='d-flex'>
                <svg className='flex-item m-r-8 m-l-4' width="30" height="30" viewBox="0 0 53 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M24.6586 33.3398C23.6338 33.3688 22.6689 33.4055 21.7638 33.4498C11.0529 33.9738 2.32213 42.9101 1.5 53.6036M50.712 56.4984L46.3698 52.1562M47.8172 44.9191C47.8172 42.6159 46.9022 40.4069 45.2735 38.7783C43.6449 37.1496 41.436 36.2347 39.1327 36.2347C36.8294 36.2347 34.6205 37.1496 32.9919 38.7783C31.3632 40.4069 30.4482 42.6159 30.4482 44.9191C30.4482 47.2224 31.3632 49.4313 32.9919 51.06C34.6205 52.6886 36.8294 53.6036 39.1327 53.6036C41.436 53.6036 43.6449 52.6886 45.2735 51.06C46.9022 49.4313 47.8172 47.2224 47.8172 44.9191Z" stroke="#ffffff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M24.6574 24.6586C31.0525 24.6586 36.2367 19.4744 36.2367 13.0793C36.2367 6.68423 31.0525 1.5 24.6574 1.5C18.2624 1.5 13.0781 6.68423 13.0781 13.0793C13.0781 19.4744 18.2624 24.6586 24.6574 24.6586Z" stroke="#ffffff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <p className="flex-item fs-22 m-l-4 font-weight-500 color-white">Manage User Lookup</p>
              </div>
              <div className='d-flex'>
                <div onClick={()=>handleSaveUserInfo()} className={`global-button-container ${isButtonLock?'global-button-container-inactive':'global-button-container-active'} button-red d-flex flex-item m-r-16`} style={{borderRadius:"20px", height:"30px"}}>
                  <p className="flex-item">Save Changes</p>
                </div>
                <div onClick={()=>props.toggleWorkoutPlanner()} className="d-flex desktop-modal-close-button flex-item" style={{width: "30px", height:"30px", background:"var(--red)"}}>
                  <svg className="flex-item" width="24" height="24" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="#ffffff" />
                  </svg>
                </div>
              </div>
            </div>
          )
        }
        <div className={`d-flex w-full space-between${isMobile ? ' mp-body--mobile' : ''}`} style={!isMobile ? {padding:"12px", height:"93%", flexDirection:"row", overflowY:"visible"} : undefined}>
          <div className={`w-full h-full${isMobile ? ' mp-panels--mobile' : ''}`} style={{borderRadius:"12px", display:"flex", ...(!isMobile ? {height:"100%", border:"1px solid #c1c1c1", flexDirection:"row"} : {})}}>
            <div className={`flex-item${isMobile ? ' mp-left-col--mobile' : ''}`} style={!isMobile ? {width:"40%", height:"100%", borderRight:"1px solid #c1c1c1", borderBottom:"none", padding:"12px 0 12px 12px"} : undefined}>
              <div className={`h-full${isMobile ? ' mp-left-inner--mobile' : ''}`} style={!isMobile ? {height:"100%", overflowY:"auto", width:"101.5%"} : undefined}>
                <div className={isMobile ? 'w-full' : 'w-full p-r-12'}>
                  <div className='flex-item d-flex'>
                    <div className="d-flex create-modal-gym-logo flex-item margin-auto" style={{marginBottom:"20px"}}>
                      {
                        userProfileImage || updatedUserInfo.profileID != '' ? (
                          <img className="flex-item" src={userProfileImage ? URL.createObjectURL(userProfileImage) : updatedUserInfo.profileID ? `${client.config.API_URL}/image/file/${updatedUserInfo.profileID}/auto/auto/70` : ""} />
                        ) : (
                          <svg width="110" height="108" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C4.477 0 0 4.477 0 10C0 15.523 4.477 20 10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 0 10 0ZM6.5 7.5C6.5 7.04037 6.59053 6.58525 6.76642 6.16061C6.94231 5.73597 7.20012 5.35013 7.52513 5.02513C7.85013 4.70012 8.23597 4.44231 8.66061 4.26642C9.08525 4.09053 9.54037 4 10 4C10.4596 4 10.9148 4.09053 11.3394 4.26642C11.764 4.44231 12.1499 4.70012 12.4749 5.02513C12.7999 5.35013 13.0577 5.73597 13.2336 6.16061C13.4095 6.58525 13.5 7.04037 13.5 7.5C13.5 8.42826 13.1313 9.3185 12.4749 9.97487C11.8185 10.6313 10.9283 11 10 11C9.07174 11 8.1815 10.6313 7.52513 9.97487C6.86875 9.3185 6.5 8.42826 6.5 7.5ZM16.258 14.984C15.5092 15.9253 14.5575 16.6855 13.4739 17.2077C12.3904 17.7299 11.2029 18.0008 10 18C8.79715 18.0008 7.60965 17.7299 6.52607 17.2077C5.44249 16.6855 4.49081 15.9253 3.742 14.984C5.363 13.821 7.575 13 10 13C12.425 13 14.637 13.821 16.258 14.984Z" fill="#C8C8C8"/>
                          </svg>
                        )
                      }

                      <div className="select-image-file-container d-flex">
                        <svg className="flex-item margin-auto" width="16" height="16" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9.5 5C12 5 14 7 14 9.5C14 12 12 14 9.5 14C7 14 5 12 5 9.5C5 7 7 5 9.5 5ZM9.5 6C8.57174 6 7.6815 6.36875 7.02513 7.02513C6.36875 7.6815 6 8.57174 6 9.5C6 10.4283 6.36875 11.3185 7.02513 11.9749C7.6815 12.6313 8.57174 13 9.5 13C10.4283 13 11.3185 12.6313 11.9749 11.9749C12.6313 11.3185 13 10.4283 13 9.5C13 8.57174 12.6313 7.6815 11.9749 7.02513C11.3185 6.36875 10.4283 6 9.5 6ZM3 2H5L7 0H12L14 2H16C16.7956 2 17.5587 2.31607 18.1213 2.87868C18.6839 3.44129 19 4.20435 19 5V14C19 14.7956 18.6839 15.5587 18.1213 16.1213C17.5587 16.6839 16.7956 17 16 17H3C2.20435 17 1.44129 16.6839 0.87868 16.1213C0.316071 15.5587 0 14.7956 0 14V5C0 4.20435 0.316071 3.44129 0.87868 2.87868C1.44129 2.31607 2.20435 2 3 2ZM7.41 1L5.41 3H3C2.46957 3 1.96086 3.21071 1.58579 3.58579C1.21071 3.96086 1 4.46957 1 5V14C1 14.5304 1.21071 15.0391 1.58579 15.4142C1.96086 15.7893 2.46957 16 3 16H16C16.5304 16 17.0391 15.7893 17.4142 15.4142C17.7893 15.0391 18 14.5304 18 14V5C18 4.46957 17.7893 3.96086 17.4142 3.58579C17.0391 3.21071 16.5304 3 16 3H13.59L11.59 1H7.41Z" fill="white"/>
                        </svg>
                      </div>

                      <input className="cursor-pointer" onChange={handleChangeImage} style={{width:"100%", height:"100%", zIndex:2, position:"absolute"}} type="file" accept="image/*" />
                    </div>
                  </div>
                  <div onClick={toggleInputFields('first-name')} className={`${(currentElementId == 'first-name' || updatedUserInfo.firstName) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'first-name' || updatedUserInfo.firstName) ? "1px solid #5D883C" : "", width: "100%" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'first-name' || updatedUserInfo.firstName) ? "10px" : "14px", color: (currentElementId == 'first-name' || updatedUserInfo.firstName) ? "var(--darkBlue)" : "", transition: "180ms" }}>First Name <span className='color-red'>*</span></p>
                    </div>
                    <input onChange={handleChange} value={updatedUserInfo.firstName ? updatedUserInfo.firstName : ""} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'first-name' || updatedUserInfo.firstName) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='Enter First Name' />
                  </div>
                  <div onClick={toggleInputFields('middle-name')} className={`${(currentElementId == 'middle-name' || updatedUserInfo.middleName) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'middle-name' || updatedUserInfo.middleName) ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'middle-name' || updatedUserInfo.middleName) ? "10px" : "14px", color: (currentElementId == 'middle-name' || updatedUserInfo.middleName) ? "var(--darkBlue)" : "", transition: "180ms" }}>Middle Name</p>
                    </div>
                    <input onChange={handleChange} value={updatedUserInfo.middleName} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'middle-name' || updatedUserInfo.middleName) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='Enter Middle Name'/>
                  </div>
                  <div onClick={toggleInputFields('last-name')} className={`${(currentElementId == 'last-name' || updatedUserInfo.lastName) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == 'last-name' || updatedUserInfo.lastName) ? "1px solid #5D883C" : "", width: "100%" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'last-name' || updatedUserInfo.lastName) ? "10px" : "14px", color: (currentElementId == 'last-name' || updatedUserInfo.lastName) ? "var(--darkBlue)" : "", transition: "180ms" }}>Last Name</p>
                    </div>
                    <input onChange={handleChange} value={updatedUserInfo.lastName} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'last-name' || updatedUserInfo.lastName) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='Enter Last Name' />
                  </div>
                  <div onClick={toggleInputFields('email-address')} className={`${(currentElementId == 'email-address' || updatedUserInfo.email) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-14`} style={{ border: (currentElementId == 'email-address' || updatedUserInfo.email) ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'email-address' || updatedUserInfo.email) ? "10px" : "14px", color: (currentElementId == 'email-address' || updatedUserInfo.email) ? "var(--darkBlue)" : "", transition: "180ms" }}>Email Address</p>
                    </div>
                    <input onChange={handleChange} value={updatedUserInfo.email} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'email-address' || updatedUserInfo.email) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='example@gmail.com' />
                  </div>
                  <div onClick={toggleInputFields('mobile-number')} className={`${(currentElementId == 'mobile-number' || updatedUserInfo.mobile) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-14`} style={{ border: (currentElementId == 'mobile-number' || updatedUserInfo.mobile) ? "1px solid #5D883C" : "", width: "100%" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'mobile-number' || updatedUserInfo.mobile) ? "10px" : "14px", color: (currentElementId == 'mobile-number' || updatedUserInfo.mobile) ? "var(--darkBlue)" : "", transition: "180ms" }}>Mobile Number <span className='color-red'>*</span></p>
                    </div>
                    <input onChange={handleChange} value={updatedUserInfo.mobile} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'mobile-number' || updatedUserInfo.mobile) ? "active-input-field" : "inactive-input-field"}`} type="number" placeholder='+91 00000-00000' />
                  </div>
                  <div onClick={toggleInputFields('password')} className={`${(currentElementId == 'password' || updatedUserInfo.password) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-14`} style={{ border: (currentElementId == 'password' || updatedUserInfo.password) ? "1px solid #5D883C" : "", width: "100%" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'password' || updatedUserInfo.password) ? "10px" : "14px", color: (currentElementId == 'password' || updatedUserInfo.password) ? "var(--darkBlue)" : "", transition: "180ms" }}>Password</p>
                    </div>
                    <input onChange={handleChange} value={updatedUserInfo.password} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'password' || updatedUserInfo.password) ? "active-input-field" : "inactive-input-field"}`} type="password" placeholder='*******' />
                  </div>
                  {/* <div onClick={toggleInputFields('password-confirmation')} className={`${(currentElementId == 'password-confirmation' || updatedUserInfo.passwordConfirmation) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-14`} style={{ border: (currentElementId == 'password-confirmation' || updatedUserInfo.passwordConfirmation) ? "1px solid #5D883C" : "", width: "100%" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'password-confirmation' || updatedUserInfo.passwordConfirmation) ? "10px" : "14px", color: (currentElementId == 'password-confirmation' || updatedUserInfo.passwordConfirmation) ? "var(--darkBlue)" : "", transition: "180ms" }}>Password Confirmation {updatedUserInfo.password != "" && <span className='color-red'>*</span>}</p>
                    </div>
                    <input onChange={handleChange} value={updatedUserInfo.passwordConfirmation} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'password-confirmation' || updatedUserInfo.passwordConfirmation) ? "active-input-field" : "inactive-input-field"}`} type="password" placeholder='*******' />
                  </div> */}

                  <p className='fs-16 font-weight-700 m-b-8'>Gender</p>

                   <div className='d-flex m-b-20' style={{gap:"20px"}}>
                    <div onClick={()=>handleRadioAction("gender", "Male")} className='d-flex cursor-pointer'>
                      <input style={{width:"20px", height:"20px"}} className='flex-item m-r-8' type='radio' name="gender" checked={updatedUserInfo.gender == "Male" ? true : false} />
                      <p className='flex-item font-weight-600 color-dark-blue fs-16'>Male</p>
                    </div>

                    <div onClick={()=>handleRadioAction("gender", "Female")} className='d-flex cursor-pointer'>
                      <input style={{width:"20px", height:"20px"}} className='flex-item m-r-8' type='radio' name="gender" checked={updatedUserInfo.gender == "Female" ? true : false} />
                      <p className='flex-item font-weight-600 color-dark-blue fs-16'>Female</p>
                    </div>

                    <div onClick={()=>handleRadioAction("gender", "Others")} className='d-flex cursor-pointer'>
                      <input style={{width:"20px", height:"20px"}} className='flex-item m-r-8' type='radio' name="gender" checked={updatedUserInfo.gender == "Others" ? true : false} />
                      <p className='flex-item font-weight-600 color-dark-blue fs-16'>Others</p>
                    </div>
                  </div>

                  <div onClick={toggleInputFields('birth-date')} className={`${(currentElementId == 'birth-date' || updatedUserInfo.dob) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-20`} style={{ border: (currentElementId == 'birth-date' || updatedUserInfo.dob) ? "1px solid #5D883C" : "", width: "100%" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'birth-date' || updatedUserInfo.dob) ? "10px" : "14px", color: (currentElementId == 'birth-date' || updatedUserInfo.dob) ? "var(--darkBlue)" : "", transition: "180ms" }}>Birth Date</p>
                    </div>
                    <input ref={birthDateRef} value={formatDateTime(updatedUserInfo.dob)} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'birth-date' || updatedUserInfo.dob) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='YYYY-MM-DD' />
                  </div>

                  <p className='fs-16 font-weight-700 m-b-8'>Marital Status</p>

                                   <div className='d-flex m-b-8' style={{gap:"20px"}}>
                    <div onClick={()=>handleRadioAction("marital-status", "single")} className='d-flex cursor-pointer'>
                      <input style={{width:"20px", height:"20px"}} className='flex-item m-r-8' type='radio' name="marital-status" checked={updatedUserInfo.maritalStatus == "single" ? true : false} />
                      <p className='flex-item font-weight-600 color-dark-blue fs-16'>Single</p>
                    </div>

                    <div onClick={()=>handleRadioAction("marital-status", "married")} className='d-flex cursor-pointer'>
                      <input style={{width:"20px", height:"20px"}} className='flex-item m-r-8' type='radio' name="marital-status" checked={updatedUserInfo.maritalStatus == "married" ? true : false} />
                      <p className='flex-item font-weight-600 color-dark-blue fs-16'>Married</p>
                    </div>
                  </div>

                  <div onClick={toggleInputFields('anniversary-date')} className={`${(currentElementId == 'anniversary-date' || updatedUserInfo.anniversaryDate) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == 'anniversary-date' || updatedUserInfo.anniversaryDate) ? "1px solid var(--darkBlue)" : "", width: "100%", visibility: updatedUserInfo.maritalStatus == "married" ? "visible" : "hidden" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'anniversary-date' || updatedUserInfo.anniversaryDate) ? "10px" : "14px", color: (currentElementId == 'anniversary-date' || updatedUserInfo.anniversaryDate) ? "#4d4d4d" : "", transition: "180ms" }}>Anniversary Date</p>
                    </div>
                    <input ref={anniversaryDateRef} value={formatDateTime(updatedUserInfo.anniversaryDate)} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'anniversary-date' || updatedUserInfo.anniversaryDate) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder='YYYY-MM-DD' />
                  </div>
                </div>
              </div>
            </div>
            <div className={`flex-item${isMobile ? ' mp-right-col--mobile' : ''}`} style={!isMobile ? {width:"60%", height:"100%", padding:"12px 0 12px 22px"} : undefined}>
              <div className={`h-full${isMobile ? ' mp-right-inner--mobile' : ''}`} style={!isMobile ? {height:"100%", overflowY:"auto", width:"101%"} : undefined}>
                <div className={isMobile ? 'w-full' : 'w-full p-r-20'}>
                  <p className='color-dark-blue font-weight-700 fs-18 m-b-12'>Gym Profile(s)</p>
                  {
                    userGymProfiles.map((userProfile, index) => {
                      return(
                        <div className='w-full gym-profile-containers m-b-12'>
                          <div className='flex-item space-between d-flex'>
                            <div className='flex-item'>
                              <p className='fs-16 font-weight-700 '>{userProfile.branchName}</p>
                              <div className='d-flex flex-item'>
                                <svg className='flex-item m-r-8' width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M5 0C2.23969 0 0 2.01594 0 4.5C0 8.5 5 14 5 14C5 14 10 8.5 10 4.5C10 2.01594 7.76031 0 5 0ZM5 7C4.60444 7 4.21776 6.8827 3.88886 6.66294C3.55996 6.44318 3.30362 6.13082 3.15224 5.76537C3.00087 5.39991 2.96126 4.99778 3.03843 4.60982C3.1156 4.22186 3.30608 3.86549 3.58579 3.58579C3.86549 3.30608 4.22186 3.1156 4.60982 3.03843C4.99778 2.96126 5.39991 3.00087 5.76537 3.15224C6.13082 3.30362 6.44318 3.55996 6.66294 3.88886C6.8827 4.21776 7 4.60444 7 5C6.99942 5.53026 6.78852 6.03863 6.41357 6.41357C6.03863 6.78852 5.53026 6.99942 5 7Z" fill="#e33a34"/>
                                </svg>
                                <p className='flex-item fs-12'>{userProfile.branchAddress}</p>
                              </div>
                            </div>
                            <div onClick={()=>handleDeleteGymProfile(userProfile)} className="d-flex desktop-modal-close-button flex-item" style={{width: "30px", height:"30px", background:"var(--red)", alignSelf:"flex-start"}}>
                              <svg className="flex-item" width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.616 15.77C2.168 15.77 1.78667 15.6127 1.472 15.298C1.15733 14.9833 1 14.6023 1 14.155V1.77H0V0.77H4V0H10V0.77H14V1.77H13V14.155C13 14.615 12.846 14.9993 12.538 15.308C12.23 15.6167 11.8453 15.7707 11.384 15.77H2.616ZM12 1.77H2V14.155C2 14.3343 2.05767 14.4817 2.173 14.597C2.28833 14.7123 2.436 14.77 2.616 14.77H11.385C11.5383 14.77 11.6793 14.706 11.808 14.578C11.9367 14.45 12.0007 14.3087 12 14.154V1.77ZM4.808 12.77H5.808V3.77H4.808V12.77ZM8.192 12.77H9.192V3.77H8.192V12.77Z" fill="#ffffff"/>
                              </svg>
                            </div>
                          </div>
                          <div onClick={toggleInputFields('roles', index)} className={`${currentElementId == 'roles' || userProfile.rolelist.length > 0 ? "member-global-input-field input-field-auto-height flex-item" : "member-global-input-field input-field-auto-height flex-item d-flex"} m-t-20`} style={{ border: currentElementId == 'roles' || userProfile.rolelist.length > 0 ? "1px solid var(--darkBlue)" : "",  width: "100%", minHeight:"60px", maxHeight:"300px", height: "auto"}}>
                            <div className='d-flex w-full space-between'>
                              <div className='flex-item w-full'>
                                <div className="flex-item d-flex">
                                  <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'roles' || userProfile.rolelist.length > 0 ? "10px" : "", color: currentElementId == 'roles' || userProfile.rolelist.length > 0 ? "var(--darkBlue)" : "", transition: "180ms" }}>User Role(s)</p>
                                </div>
                                <div onClick={e => e.stopPropagation()} className="d-flex-wrap" style={{maxWidth:"90%"}}>
                                  {
                                    userProfile.rolelist && userProfile.rolelist.length > 0 && (
                                      userProfile.rolelist.map((data,subIndex) => {
                                        return(
                                          <div className="flex-item d-flex input-field-chips m-r-12 m-t-2 m-b-8">
                                            <p className="flex-item m-r-12">{client.config.roleNames[data.name]}</p>
                                            <svg onClick={()=>handleRemoveRole(index,subIndex)} className="flex-item" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M1 7L7 1M7 7L1 1" stroke="#E52525" stroke-miterlimit="10" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                          </div>
                                        )
                                      })
                                    )
                                  }
                                </div>
                              </div>
                              <div className='input-field-arrow-dropdown' style={{ transform: currentDropDownType == 'roles' && selectedProfileIndex == index ? "rotate(180deg)" : "", margin: "18px 16px 4px 0", transition: "180ms" }}>
                                <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                                </svg>
                              </div>
                            </div>
                            {
                              currentDropDownType == 'roles' && selectedProfileIndex == index && (
                                <div onClick={e=>e.stopPropagation()} className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1" style={{top:"auto", bottom:"-270px"}}>
                                  {
                                    roles.filter(data => !userProfile.rolelist.some(assigned => assigned.name === data.name))
                                    .map(data => {
                                      return(  
                                        <div onClick={()=>handleAssignRole(data, index)} className="global-input-field-arrow-dropdown-item">
                                          <p className="flex-item">{client.config.roleNames[data.name]}</p>
                                        </div>
                                      )
                                    })
                                  }
                                </div>
                              )
                            }
                          </div>
                        </div>
                      )
                    })
                  }

                  {/* Add New Profile */}
                  {
                    !isAddNewProfileSectionOpen && (
                      <div className='d-flex'>
                        <div onClick={()=>handleAddNewProfileSectionOpen()} className="global-button-container global-button-container-active button-red d-flex flex-item" style={{borderRadius:"20px", height:"30px"}}>
                          <p className="flex-item">Add New Profile</p>
                        </div>  
                      </div>
                    )
                  }
                  {
                    isAddNewProfileSectionOpen && (
                      <div className='w-full gym-profile-containers m-b-12'>
                        <div className='d-flex m-b-8'>
                          <p className='flex-item font-weight-700 fs-16 m-r-12'>New Profile</p>
                          <div onClick={()=>handleAddNewProfileSectionOpen()} className="d-flex desktop-modal-close-button flex-item" style={{width: "20px", height:"20px", background:"var(--red)"}}>
                            <svg className="flex-item" width="16" height="16" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="#ffffff" />
                            </svg>
                          </div>
                        </div>
                        <div className="select-global-gym flex-item d-flex cursor-pointer">  
                          {
                            window.innerWidth < 768 ? (
                              <div className="d-flex margin-auto flex-item" onClick={(e)=>e.stopPropagation()}>
                                <div onClick={toggleGymList} className="margin-auto">
                                  <div className="flex-item d-flex">
                                    <p className="flex-item m-r-4 font-weight-700 color-dark-blue fs-16">{selectedGym && selectedGym.name.length > 0 ? selectedGym.name.length > 12 ?  selectedGym.name.slice(0, 12) + "..." : selectedGym.name : "Select Gym"}</p>
                                    <svg className={`flex-item mp-toggle-arrow${isGymListOpen ? ' mp-toggle-arrow--open' : ''}`} width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M7.04883 10L12.0488 15L17.0488 10" stroke="#6D6D6D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                  </div>
                                  {
                                    user.role == 0 ? 
                                      <div className="d-flex flex-item">
                                        <svg className="flex-item m-r-2" width="12" height="12" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M5 7.64584C4.5264 7.64584 4.0722 7.45927 3.73731 7.12717C3.40242 6.79508 3.21429 6.34466 3.21429 5.87501C3.21429 5.40535 3.40242 4.95493 3.73731 4.62284C4.0722 4.29074 4.5264 4.10417 5 4.10417C5.4736 4.10417 5.9278 4.29074 6.26269 4.62284C6.59758 4.95493 6.78571 5.40535 6.78571 5.87501C6.78571 6.10755 6.73953 6.33783 6.64979 6.55267C6.56004 6.76752 6.42851 6.96274 6.26269 7.12717C6.09687 7.29161 5.90002 7.42205 5.68336 7.51104C5.46671 7.60004 5.2345 7.64584 5 7.64584ZM5 0.916672C3.67392 0.916672 2.40215 1.43907 1.46447 2.36893C0.526784 3.2988 0 4.55997 0 5.87501C0 9.59376 5 15.0833 5 15.0833C5 15.0833 10 9.59376 10 5.87501C10 4.55997 9.47322 3.2988 8.53553 2.36893C7.59785 1.43907 6.32608 0.916672 5 0.916672Z" fill="#CC0000"/>
                                        </svg>
                                        <p className="fs-10 flex-item font-weight-400 color-grey-03" style={{lineHeight:"10px"}}>{selectedGym.address}</p>
                                      </div>:<div className="d-flex flex-item">
                                        <svg className="flex-item m-r-2" width="12" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M9.13045 12.7826H7.91305C7.59018 12.7826 7.28053 12.6543 7.05223 12.426C6.82392 12.1977 6.69566 11.8881 6.69566 11.5652C6.69566 11.2423 6.82392 10.9327 7.05223 10.7044C7.28053 10.4761 7.59018 10.3478 7.91305 10.3478H9.13045V9.13043H7.91305C7.26731 9.13043 6.64801 9.38695 6.1914 9.84356C5.73479 10.3002 5.47827 10.9195 5.47827 11.5652C5.47827 12.211 5.73479 12.8303 6.1914 13.2869C6.64801 13.7435 7.26731 14 7.91305 14H9.13045V12.7826ZM14 11.5652C14 12.211 13.7435 12.8303 13.2869 13.2869C12.8303 13.7435 12.211 14 11.5652 14H10.3478V12.7826H11.5652C11.8881 12.7826 12.1977 12.6543 12.4261 12.426C12.6544 12.1977 12.7826 11.8881 12.7826 11.5652C12.7826 11.2423 12.6544 10.9327 12.4261 10.7044C12.1977 10.4761 11.8881 10.3478 11.5652 10.3478H10.3478V9.13043H11.5652C12.211 9.13043 12.8303 9.38695 13.2869 9.84356C13.7435 10.3002 14 10.9195 14 11.5652Z" fill="#E33A34"/>
                                          <path d="M8.52174 10.9566H10.9565V12.174H8.52174V10.9566ZM4.26087 11.5653C4.26209 11.3613 4.28042 11.1577 4.31565 10.9566H1.82609V10.1045C1.82609 8.88708 4.26087 8.21751 5.47826 8.21751C5.75375 8.22121 6.02852 8.24665 6.3 8.2936C6.80105 8.04382 7.35319 7.9136 7.91304 7.91317H10.9565V2.43491C10.9556 2.11233 10.827 1.80324 10.5989 1.57514C10.3708 1.34705 10.0617 1.21848 9.73913 1.21751H7.19478C7.07015 0.861695 6.83801 0.553401 6.5305 0.335282C6.22298 0.117163 5.85528 0 5.47826 0C5.10124 0 4.73354 0.117163 4.42603 0.335282C4.11851 0.553401 3.88638 0.861695 3.76174 1.21751H1.21739C0.894815 1.21848 0.585727 1.34705 0.35763 1.57514C0.129533 1.80324 0.000963399 2.11233 0 2.43491L0 10.9566C0.000963399 11.2792 0.129533 11.5883 0.35763 11.8164C0.585727 12.0445 0.894815 12.1731 1.21739 12.174H4.31565C4.28042 11.973 4.26209 11.7694 4.26087 11.5653ZM5.47826 1.21751C5.59865 1.21751 5.71634 1.25321 5.81643 1.3201C5.91653 1.38698 5.99455 1.48205 6.04062 1.59327C6.08669 1.7045 6.09875 1.82689 6.07526 1.94496C6.05177 2.06304 5.9938 2.1715 5.90867 2.25662C5.82355 2.34175 5.71509 2.39972 5.59701 2.42321C5.47894 2.4467 5.35655 2.43464 5.24532 2.38857C5.1341 2.3425 5.03903 2.26448 4.97215 2.16438C4.90526 2.06428 4.86957 1.9466 4.86957 1.82621C4.87005 1.66492 4.93433 1.51038 5.04838 1.39633C5.16243 1.28228 5.31697 1.218 5.47826 1.21751ZM5.47826 3.6523C5.83943 3.6523 6.19248 3.7594 6.49278 3.96005C6.79308 4.1607 7.02713 4.4459 7.16535 4.77957C7.30356 5.11324 7.33972 5.48041 7.26926 5.83464C7.1988 6.18886 7.02488 6.51424 6.7695 6.76962C6.51412 7.02501 6.18874 7.19892 5.83451 7.26938C5.48029 7.33984 5.11312 7.30368 4.77945 7.16547C4.44577 7.02726 4.16058 6.7932 3.95993 6.4929C3.75927 6.1926 3.65217 5.83955 3.65217 5.47838C3.65185 5.23849 3.69887 5.00089 3.79052 4.77919C3.88218 4.5575 4.01668 4.35606 4.18631 4.18643C4.35594 4.0168 4.55737 3.8823 4.77907 3.79065C5.00076 3.69899 5.23837 3.65198 5.47826 3.6523Z" fill="#E33A34"/>
                                        </svg>
                                        <p className="fs-10 flex-item font-weight-400 color-grey-03" style={{lineHeight:"10px"}}>{client.config.roleNames[selectedGym.roleName]}</p>
                                      </div>
                                  }
                                </div>
                              </div>
                            ) : (
                              <div onClick={(e)=>e.stopPropagation()} className="d-flex w-full" >
                                {
                                  !selectedGym ? (
                                    <div className="w-full d-flex flex-item m-r-20">
                                      <p className="flex-item font-weight-700 color-dark-blue fs-16">Select Gym</p>
                                    </div>
                                  ) : (
                                    <div className="w-full d-flex m-r-20">
                                      {
                                        selectedGym.logoFileID ? (
                                          <div className='selected-gym-logo flex-item m-r-8'>
                                            <img src={`${client.config.API_URL}/image/file/${selectedGym.logoFileID}/auto/auto/70`} loading='lazy' />
                                          </div>
                                        ) : (
                                          <div className="selected-gym-logo m-r-8 flex-item d-flex" style={{backgroundColor: "#5d883c"}}>
                                            <p className='flex-item' style={{color: "#ffffff", margin: "0 auto", fontSize: 14}}>{`${selectedGym.name}`.trim()[0]}</p>
                                          </div>
                                        ) 
                                      }
                                      <div onClick={toggleGymList} className="selected-gym-name flex-item">
                                        <p className="w-full flex-item m-r-4 font-weight-700 color-dark-blue fs-14">{selectedGym && selectedGym.name.length > 0 ? selectedGym.name.length > 22 ?  selectedGym.name.slice(0, 22) + "..." : selectedGym.name : "NULL"}</p>        
                                        {
                                          user.role == 0 ?
                                          <div className="d-flex m-t-0">
                                            <svg className="flex-item m-r-2" width="14" height="14" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M5 7.64584C4.5264 7.64584 4.0722 7.45927 3.73731 7.12717C3.40242 6.79508 3.21429 6.34466 3.21429 5.87501C3.21429 5.40535 3.40242 4.95493 3.73731 4.62284C4.0722 4.29074 4.5264 4.10417 5 4.10417C5.4736 4.10417 5.9278 4.29074 6.26269 4.62284C6.59758 4.95493 6.78571 5.40535 6.78571 5.87501C6.78571 6.10755 6.73953 6.33783 6.64979 6.55267C6.56004 6.76752 6.42851 6.96274 6.26269 7.12717C6.09687 7.29161 5.90002 7.42205 5.68336 7.51104C5.46671 7.60004 5.2345 7.64584 5 7.64584ZM5 0.916672C3.67392 0.916672 2.40215 1.43907 1.46447 2.36893C0.526784 3.2988 0 4.55997 0 5.87501C0 9.59376 5 15.0833 5 15.0833C5 15.0833 10 9.59376 10 5.87501C10 4.55997 9.47322 3.2988 8.53553 2.36893C7.59785 1.43907 6.32608 0.916672 5 0.916672Z" fill="#CC0000"/>
                                            </svg>
                                            <p className="fs-12 flex-item font-weight-400 color-grey-03" style={{lineHeight:"12px"}}>{selectedGym.address && selectedGym.address.length > 30 ? selectedGym.address.slice(0, 30) + "..." : selectedGym.address && selectedGym.address.length < 30 ? selectedGym.address : "--" }</p>
                                          </div>:
                                          <div className="d-flex m-t-0">
                                            <svg className="flex-item m-r-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M9.13045 12.7826H7.91305C7.59018 12.7826 7.28053 12.6543 7.05223 12.426C6.82392 12.1977 6.69566 11.8881 6.69566 11.5652C6.69566 11.2423 6.82392 10.9327 7.05223 10.7044C7.28053 10.4761 7.59018 10.3478 7.91305 10.3478H9.13045V9.13043H7.91305C7.26731 9.13043 6.64801 9.38695 6.1914 9.84356C5.73479 10.3002 5.47827 10.9195 5.47827 11.5652C5.47827 12.211 5.73479 12.8303 6.1914 13.2869C6.64801 13.7435 7.26731 14 7.91305 14H9.13045V12.7826ZM14 11.5652C14 12.211 13.7435 12.8303 13.2869 13.2869C12.8303 13.7435 12.211 14 11.5652 14H10.3478V12.7826H11.5652C11.8881 12.7826 12.1977 12.6543 12.4261 12.426C12.6544 12.1977 12.7826 11.8881 12.7826 11.5652C12.7826 11.2423 12.6544 10.9327 12.4261 10.7044C12.1977 10.4761 11.8881 10.3478 11.5652 10.3478H10.3478V9.13043H11.5652C12.211 9.13043 12.8303 9.38695 13.2869 9.84356C13.7435 10.3002 14 10.9195 14 11.5652Z" fill="#E33A34"/>
                                              <path d="M8.52174 10.9566H10.9565V12.174H8.52174V10.9566ZM4.26087 11.5653C4.26209 11.3613 4.28042 11.1577 4.31565 10.9566H1.82609V10.1045C1.82609 8.88708 4.26087 8.21751 5.47826 8.21751C5.75375 8.22121 6.02852 8.24665 6.3 8.2936C6.80105 8.04382 7.35319 7.9136 7.91304 7.91317H10.9565V2.43491C10.9556 2.11233 10.827 1.80324 10.5989 1.57514C10.3708 1.34705 10.0617 1.21848 9.73913 1.21751H7.19478C7.07015 0.861695 6.83801 0.553401 6.5305 0.335282C6.22298 0.117163 5.85528 0 5.47826 0C5.10124 0 4.73354 0.117163 4.42603 0.335282C4.11851 0.553401 3.88638 0.861695 3.76174 1.21751H1.21739C0.894815 1.21848 0.585727 1.34705 0.35763 1.57514C0.129533 1.80324 0.000963399 2.11233 0 2.43491L0 10.9566C0.000963399 11.2792 0.129533 11.5883 0.35763 11.8164C0.585727 12.0445 0.894815 12.1731 1.21739 12.174H4.31565C4.28042 11.973 4.26209 11.7694 4.26087 11.5653ZM5.47826 1.21751C5.59865 1.21751 5.71634 1.25321 5.81643 1.3201C5.91653 1.38698 5.99455 1.48205 6.04062 1.59327C6.08669 1.7045 6.09875 1.82689 6.07526 1.94496C6.05177 2.06304 5.9938 2.1715 5.90867 2.25662C5.82355 2.34175 5.71509 2.39972 5.59701 2.42321C5.47894 2.4467 5.35655 2.43464 5.24532 2.38857C5.1341 2.3425 5.03903 2.26448 4.97215 2.16438C4.90526 2.06428 4.86957 1.9466 4.86957 1.82621C4.87005 1.66492 4.93433 1.51038 5.04838 1.39633C5.16243 1.28228 5.31697 1.218 5.47826 1.21751ZM5.47826 3.6523C5.83943 3.6523 6.19248 3.7594 6.49278 3.96005C6.79308 4.1607 7.02713 4.4459 7.16535 4.77957C7.30356 5.11324 7.33972 5.48041 7.26926 5.83464C7.1988 6.18886 7.02488 6.51424 6.7695 6.76962C6.51412 7.02501 6.18874 7.19892 5.83451 7.26938C5.48029 7.33984 5.11312 7.30368 4.77945 7.16547C4.44577 7.02726 4.16058 6.7932 3.95993 6.4929C3.75927 6.1926 3.65217 5.83955 3.65217 5.47838C3.65185 5.23849 3.69887 5.00089 3.79052 4.77919C3.88218 4.5575 4.01668 4.35606 4.18631 4.18643C4.35594 4.0168 4.55737 3.8823 4.77907 3.79065C5.00076 3.69899 5.23837 3.65198 5.47826 3.6523Z" fill="#E33A34"/>
                                            </svg>
                                            <p className="fs-12 flex-item font-weight-400 color-grey-03" style={{lineHeight:"12px"}}>{client.config.roleNames[selectedGym.roleName]}</p>
                                          </div>
                                        }
                                      </div>
                                    </div>
                                  )
                                }

                                <div onClick={toggleGymList} className="table-action-button d-flex" style={{backgroundColor: isGymListOpen ? "#E33A34" : "var(--darkBlue)", minWidth:"30px", maxWidth:"30px"}}>
                                  <svg className="flex-item svg-stroke margin-auto" style={{transition:"180ms", transform: isGymListOpen ? "rotate(180deg)" : "rotate(0deg)"}} width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.5 0.5L7 7.5L13.5 0.5" stroke="#ffffff" stroke-linecap="round"/>
                                  </svg>
                                </div>
                                
                              </div>
                            )
                          }
                        
                          {
                            isGymListOpen && [
                              <div onClick={(e)=>e.stopPropagation()} className="w-full gym-list-container slideTopToBottom">
                                {
                                  window.innerWidth < 768 && (
                                    <div className="w-full selected-gym-list-container d-flex space-between">
                                      {
                                        selectedGym ? (
                                          <div className="gym-selected-container w-full d-flex">
                                            {
                                              selectedGym.logoFileID ? (
                                                <div className='selected-gym-logo flex-item m-r-8'>
                                                  <img src={`${client.config.API_URL}/image/file/${selectedGym.logoFileID}/auto/auto/70`} loading='lazy' />
                                                </div>
                                              ) : (
                                                <div className="selected-gym-logo m-r-8 flex-item d-flex" style={{backgroundColor: "#5d883c"}}>
                                                  <p className='flex-item' style={{color: "#ffffff", margin: "0 auto", fontSize: 14}}>{`${selectedGym.name}`.trim()[0]}</p>
                                                </div>
                                              ) 
                                            }
                                            <div className="selected-gym-name flex-item">
                                              <p className="w-full flex-item m-r-4 font-weight-700 color-dark-blue fs-16">{selectedGym && selectedGym.name.length > 0 ? selectedGym.name.length > 22 ?  selectedGym.name.slice(0, 22) + "..." : selectedGym.name : "NULL"}</p>        
                                            {user.role == 0 ? <div className="d-flex m-t-4">
                                                <svg className="flex-item m-r-2" width="14" height="14" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <path d="M5 7.64584C4.5264 7.64584 4.0722 7.45927 3.73731 7.12717C3.40242 6.79508 3.21429 6.34466 3.21429 5.87501C3.21429 5.40535 3.40242 4.95493 3.73731 4.62284C4.0722 4.29074 4.5264 4.10417 5 4.10417C5.4736 4.10417 5.9278 4.29074 6.26269 4.62284C6.59758 4.95493 6.78571 5.40535 6.78571 5.87501C6.78571 6.10755 6.73953 6.33783 6.64979 6.55267C6.56004 6.76752 6.42851 6.96274 6.26269 7.12717C6.09687 7.29161 5.90002 7.42205 5.68336 7.51104C5.46671 7.60004 5.2345 7.64584 5 7.64584ZM5 0.916672C3.67392 0.916672 2.40215 1.43907 1.46447 2.36893C0.526784 3.2988 0 4.55997 0 5.87501C0 9.59376 5 15.0833 5 15.0833C5 15.0833 10 9.59376 10 5.87501C10 4.55997 9.47322 3.2988 8.53553 2.36893C7.59785 1.43907 6.32608 0.916672 5 0.916672Z" fill="#CC0000"/>
                                                </svg>
                                                <p className="fs-12 flex-item font-weight-400 color-grey-03" style={{lineHeight:"12px"}}>{selectedGym.address}</p>
                                              </div>:<div className="d-flex m-t-4">
                                                <svg className="flex-item m-r-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <path d="M9.13045 12.7826H7.91305C7.59018 12.7826 7.28053 12.6543 7.05223 12.426C6.82392 12.1977 6.69566 11.8881 6.69566 11.5652C6.69566 11.2423 6.82392 10.9327 7.05223 10.7044C7.28053 10.4761 7.59018 10.3478 7.91305 10.3478H9.13045V9.13043H7.91305C7.26731 9.13043 6.64801 9.38695 6.1914 9.84356C5.73479 10.3002 5.47827 10.9195 5.47827 11.5652C5.47827 12.211 5.73479 12.8303 6.1914 13.2869C6.64801 13.7435 7.26731 14 7.91305 14H9.13045V12.7826ZM14 11.5652C14 12.211 13.7435 12.8303 13.2869 13.2869C12.8303 13.7435 12.211 14 11.5652 14H10.3478V12.7826H11.5652C11.8881 12.7826 12.1977 12.6543 12.4261 12.426C12.6544 12.1977 12.7826 11.8881 12.7826 11.5652C12.7826 11.2423 12.6544 10.9327 12.4261 10.7044C12.1977 10.4761 11.8881 10.3478 11.5652 10.3478H10.3478V9.13043H11.5652C12.211 9.13043 12.8303 9.38695 13.2869 9.84356C13.7435 10.3002 14 10.9195 14 11.5652Z" fill="#E33A34"/>
                                                  <path d="M8.52174 10.9566H10.9565V12.174H8.52174V10.9566ZM4.26087 11.5653C4.26209 11.3613 4.28042 11.1577 4.31565 10.9566H1.82609V10.1045C1.82609 8.88708 4.26087 8.21751 5.47826 8.21751C5.75375 8.22121 6.02852 8.24665 6.3 8.2936C6.80105 8.04382 7.35319 7.9136 7.91304 7.91317H10.9565V2.43491C10.9556 2.11233 10.827 1.80324 10.5989 1.57514C10.3708 1.34705 10.0617 1.21848 9.73913 1.21751H7.19478C7.07015 0.861695 6.83801 0.553401 6.5305 0.335282C6.22298 0.117163 5.85528 0 5.47826 0C5.10124 0 4.73354 0.117163 4.42603 0.335282C4.11851 0.553401 3.88638 0.861695 3.76174 1.21751H1.21739C0.894815 1.21848 0.585727 1.34705 0.35763 1.57514C0.129533 1.80324 0.000963399 2.11233 0 2.43491L0 10.9566C0.000963399 11.2792 0.129533 11.5883 0.35763 11.8164C0.585727 12.0445 0.894815 12.1731 1.21739 12.174H4.31565C4.28042 11.973 4.26209 11.7694 4.26087 11.5653ZM5.47826 1.21751C5.59865 1.21751 5.71634 1.25321 5.81643 1.3201C5.91653 1.38698 5.99455 1.48205 6.04062 1.59327C6.08669 1.7045 6.09875 1.82689 6.07526 1.94496C6.05177 2.06304 5.9938 2.1715 5.90867 2.25662C5.82355 2.34175 5.71509 2.39972 5.59701 2.42321C5.47894 2.4467 5.35655 2.43464 5.24532 2.38857C5.1341 2.3425 5.03903 2.26448 4.97215 2.16438C4.90526 2.06428 4.86957 1.9466 4.86957 1.82621C4.87005 1.66492 4.93433 1.51038 5.04838 1.39633C5.16243 1.28228 5.31697 1.218 5.47826 1.21751ZM5.47826 3.6523C5.83943 3.6523 6.19248 3.7594 6.49278 3.96005C6.79308 4.1607 7.02713 4.4459 7.16535 4.77957C7.30356 5.11324 7.33972 5.48041 7.26926 5.83464C7.1988 6.18886 7.02488 6.51424 6.7695 6.76962C6.51412 7.02501 6.18874 7.19892 5.83451 7.26938C5.48029 7.33984 5.11312 7.30368 4.77945 7.16547C4.44577 7.02726 4.16058 6.7932 3.95993 6.4929C3.75927 6.1926 3.65217 5.83955 3.65217 5.47838C3.65185 5.23849 3.69887 5.00089 3.79052 4.77919C3.88218 4.5575 4.01668 4.35606 4.18631 4.18643C4.35594 4.0168 4.55737 3.8823 4.77907 3.79065C5.00076 3.69899 5.23837 3.65198 5.47826 3.6523Z" fill="#E33A34"/>
                                                </svg>
                                                <p className="fs-12 flex-item font-weight-400 color-grey-03" style={{lineHeight:"12px"}}>{client.config.roleNames[selectedGym.roleName]}</p>
                                              </div>}
                                            </div>
                                          </div>
                                        ) : (
                                          <p className="selected-gym-name flex-item m-r-4 font-weight-700 color-dark-blue fs-20">Select Gym</p>        
                                        )
                                      }
                                      <div onClick={toggleGymList} className={`table-action-button d-flex mp-toggle-btn${isGymListOpen ? ' mp-toggle-btn--open' : ''}`}>
                                        <svg className={`flex-item svg-stroke margin-auto mp-toggle-arrow${isGymListOpen ? ' mp-toggle-arrow--open' : ''}`} width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M0.5 0.5L7 7.5L13.5 0.5" stroke={isGymListOpen ? "#ffffff" : "#9A9A9A"} stroke-linecap="round"/>
                                        </svg>
                                      </div>
                                    </div>
                                  )
                                }
                                {user.role == 0 && <div className={`w-full ${window.innerWidth > 767 && "p-t-12 p-l-12 p-r-12"}`}>
                                  <SearchFilter count={totalGyms} isFilterDropdown={true} searchType={"Gym"} filterSection="gym-filter"  isSearchEnabled={true} searchingData={handleSearchingData} isFilterEnabled={false} searchFieldWidth={window.innerWidth > 767 ? 240 : ""}/>
                                </div>}
                                <div className={`gym-list ${window.innerWidth > 767 && "m-t-16"} ${isMobile ? 'mp-gym-list--mobile' : ''} ${isMobile && selectedGym != null ? 'mp-gym-list--mobile-selected' : ''}`} onScroll={user.role==0 && handleGymScroll}>
                                  
                                  {
                                    gymList.map(data => {
                                      return(
                                        <div onClick={()=>handleSelectGym(data)} className="d-flex cursor-pointer gyms-list-item">
                                          {
                                            data.logoFileID ? (
                                              <div className='gym-list-logo flex-item m-r-12'>
                                                <img id="gym-ImgWrapper" src={`${client.config.API_URL}/image/file/${data.logoFileID}/auto/auto/70`} loading='lazy' />
                                              </div>
                                            ) : (
                                              <div className="gym-list-logo m-r-12 flex-item d-flex" style={{backgroundColor: "#5d883c"}}>
                                                <p className='flex-item' style={{color: "#ffffff", margin: "0 auto", fontSize: 14}}>{`${data.name}`.trim()[0]}</p>
                                              </div>
                                            ) 
                                          }
                                          <div className="flex-item">
                                            <p className="font-weight-700 color-dark-blue" style={{lineHeight:"16px"}}>{data.name}</p>
                                            <div className="d-flex m-t-4">
                                            {!data.roleName ? <svg className="flex-item m-r-2" width="14" height="14" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M5 7.64584C4.5264 7.64584 4.0722 7.45927 3.73731 7.12717C3.40242 6.79508 3.21429 6.34466 3.21429 5.87501C3.21429 5.40535 3.40242 4.95493 3.73731 4.62284C4.0722 4.29074 4.5264 4.10417 5 4.10417C5.4736 4.10417 5.9278 4.29074 6.26269 4.62284C6.59758 4.95493 6.78571 5.40535 6.78571 5.87501C6.78571 6.10755 6.73953 6.33783 6.64979 6.55267C6.56004 6.76752 6.42851 6.96274 6.26269 7.12717C6.09687 7.29161 5.90002 7.42205 5.68336 7.51104C5.46671 7.60004 5.2345 7.64584 5 7.64584ZM5 0.916672C3.67392 0.916672 2.40215 1.43907 1.46447 2.36893C0.526784 3.2988 0 4.55997 0 5.87501C0 9.59376 5 15.0833 5 15.0833C5 15.0833 10 9.59376 10 5.87501C10 4.55997 9.47322 3.2988 8.53553 2.36893C7.59785 1.43907 6.32608 0.916672 5 0.916672Z" fill="#CC0000"/>
                                              </svg>:<svg className="flex-item m-r-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9.13045 12.7826H7.91305C7.59018 12.7826 7.28053 12.6543 7.05223 12.426C6.82392 12.1977 6.69566 11.8881 6.69566 11.5652C6.69566 11.2423 6.82392 10.9327 7.05223 10.7044C7.28053 10.4761 7.59018 10.3478 7.91305 10.3478H9.13045V9.13043H7.91305C7.26731 9.13043 6.64801 9.38695 6.1914 9.84356C5.73479 10.3002 5.47827 10.9195 5.47827 11.5652C5.47827 12.211 5.73479 12.8303 6.1914 13.2869C6.64801 13.7435 7.26731 14 7.91305 14H9.13045V12.7826ZM14 11.5652C14 12.211 13.7435 12.8303 13.2869 13.2869C12.8303 13.7435 12.211 14 11.5652 14H10.3478V12.7826H11.5652C11.8881 12.7826 12.1977 12.6543 12.4261 12.426C12.6544 12.1977 12.7826 11.8881 12.7826 11.5652C12.7826 11.2423 12.6544 10.9327 12.4261 10.7044C12.1977 10.4761 11.8881 10.3478 11.5652 10.3478H10.3478V9.13043H11.5652C12.211 9.13043 12.8303 9.38695 13.2869 9.84356C13.7435 10.3002 14 10.9195 14 11.5652Z" fill="#E33A34"/>
                                                <path d="M8.52174 10.9566H10.9565V12.174H8.52174V10.9566ZM4.26087 11.5653C4.26209 11.3613 4.28042 11.1577 4.31565 10.9566H1.82609V10.1045C1.82609 8.88708 4.26087 8.21751 5.47826 8.21751C5.75375 8.22121 6.02852 8.24665 6.3 8.2936C6.80105 8.04382 7.35319 7.9136 7.91304 7.91317H10.9565V2.43491C10.9556 2.11233 10.827 1.80324 10.5989 1.57514C10.3708 1.34705 10.0617 1.21848 9.73913 1.21751H7.19478C7.07015 0.861695 6.83801 0.553401 6.5305 0.335282C6.22298 0.117163 5.85528 0 5.47826 0C5.10124 0 4.73354 0.117163 4.42603 0.335282C4.11851 0.553401 3.88638 0.861695 3.76174 1.21751H1.21739C0.894815 1.21848 0.585727 1.34705 0.35763 1.57514C0.129533 1.80324 0.000963399 2.11233 0 2.43491L0 10.9566C0.000963399 11.2792 0.129533 11.5883 0.35763 11.8164C0.585727 12.0445 0.894815 12.1731 1.21739 12.174H4.31565C4.28042 11.973 4.26209 11.7694 4.26087 11.5653ZM5.47826 1.21751C5.59865 1.21751 5.71634 1.25321 5.81643 1.3201C5.91653 1.38698 5.99455 1.48205 6.04062 1.59327C6.08669 1.7045 6.09875 1.82689 6.07526 1.94496C6.05177 2.06304 5.9938 2.1715 5.90867 2.25662C5.82355 2.34175 5.71509 2.39972 5.59701 2.42321C5.47894 2.4467 5.35655 2.43464 5.24532 2.38857C5.1341 2.3425 5.03903 2.26448 4.97215 2.16438C4.90526 2.06428 4.86957 1.9466 4.86957 1.82621C4.87005 1.66492 4.93433 1.51038 5.04838 1.39633C5.16243 1.28228 5.31697 1.218 5.47826 1.21751ZM5.47826 3.6523C5.83943 3.6523 6.19248 3.7594 6.49278 3.96005C6.79308 4.1607 7.02713 4.4459 7.16535 4.77957C7.30356 5.11324 7.33972 5.48041 7.26926 5.83464C7.1988 6.18886 7.02488 6.51424 6.7695 6.76962C6.51412 7.02501 6.18874 7.19892 5.83451 7.26938C5.48029 7.33984 5.11312 7.30368 4.77945 7.16547C4.44577 7.02726 4.16058 6.7932 3.95993 6.4929C3.75927 6.1926 3.65217 5.83955 3.65217 5.47838C3.65185 5.23849 3.69887 5.00089 3.79052 4.77919C3.88218 4.5575 4.01668 4.35606 4.18631 4.18643C4.35594 4.0168 4.55737 3.8823 4.77907 3.79065C5.00076 3.69899 5.23837 3.65198 5.47826 3.6523Z" fill="#E33A34"/>
                                                </svg>}
                                              <p className="fs-12 flex-item font-weight-400 color-grey-03" style={{lineHeight:"12px"}}>{data.roleName?client.config.roleNames[data.roleName]:data.address && data.address.length > 50 ? data.address.slice(0, 50) + "..." : data.address && data.address.length < 50 ? data.address : "--" }</p>
                                            </div>
                                          </div>
                                        </div>
                                      )
                                    })
                                  }
                                {isBranchSpinnerLoader && <div className="loader-5 center"><span></span></div>}
                                </div>
                              </div>,
                              window.innerWidth < 768 && (
                                <div onClick={toggleGymList} className="modal-bg-blur mp-modal-backdrop"/>
                              )
                            ]
                          }

                        </div>

                        {
                          selectedGym != "" && (
                            <div onClick={toggleInputFields('selected-roles')} className={`${currentElementId == 'selected-roles' || selectedRoles.length > 0 ? "member-global-input-field input-field-auto-height flex-item" : "member-global-input-field input-field-auto-height flex-item d-flex"} m-t-20`} style={{ border: currentElementId == 'selected-roles' || selectedRoles.length > 0 ? "1px solid var(--darkBlue)" : "",  width: "100%", minHeight:"60px", maxHeight:"300px", height: "auto"}}>
                              <div className='d-flex w-full space-between'>
                                <div className='flex-item w-full'>
                                  <div className="flex-item d-flex">
                                    <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'selected-roles' || selectedRoles.length > 0 ? "10px" : "", color: currentElementId == 'selected-roles' || selectedRoles.length > 0 ? "var(--darkBlue)" : "", transition: "180ms" }}>User Role(s)</p>
                                  </div>
                                  <div onClick={e => e.stopPropagation()} className="d-flex-wrap" style={{maxWidth:"90%"}}>
                                    {
                                      selectedRoles.length > 0 && (
                                        selectedRoles.map((data,index) => {
                                          return(
                                            <div className="flex-item d-flex input-field-chips m-r-12 m-t-2 m-b-8">
                                              <p className="flex-item m-r-12">{client.config.roleNames[data.name]}</p>
                                              <svg onClick={()=>handleRemoveSelectedRole(index)} className="flex-item" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1 7L7 1M7 7L1 1" stroke="#E52525" stroke-miterlimit="10" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                              </svg>
                                            </div>
                                          )
                                        })
                                      )
                                    }
                                  </div>
                                </div>
                                <div className='input-field-arrow-dropdown' style={{ transform: currentDropDownType == 'selected-roles' ? "rotate(180deg)" : "", margin: "18px 16px 4px 0", transition: "180ms" }}>
                                  <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                                  </svg>
                                </div>
                              </div>
                              {
                                currentDropDownType == 'selected-roles' && (
                                  <div onClick={e=>e.stopPropagation()} className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1" style={{top:"auto", bottom:"-270px"}}>
                                    {
                                      roles.filter(data => !selectedRoles.some(assigned => assigned.name === data.name))
                                      .map((data, index) => {
                                        return(  
                                          <div onClick={()=>handleAssignSelectedRole(data, index)} className="global-input-field-arrow-dropdown-item">
                                            <p className="flex-item">{client.config.roleNames[data.name]}</p>
                                          </div>
                                        )
                                      })
                                    }
                                  </div>
                                )
                              }
                            </div>
                          )
                        }

                        {
                          selectedRoles.length > 0 && selectedGym != "" && (
                            <div className='d-flex m-t-12'>
                              <div onClick={()=>handleAddNewProfile()} className={`global-button-container ${isButtonLock?'global-button-container-inactive':'global-button-container-active'} button-red d-flex flex-item m-r-16`} style={{borderRadius:"20px", height:"30px"}}>
                                <p className="flex-item">Add</p>
                              </div>
                            </div>
                          )
                        }
                      </div>
                    )
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        {
          isMobile && (
            <div className='d-flex w-full mp-save-bar'>
              <div onClick={()=>handleSaveUserInfo()} className="d-flex flex-item mp-save-bar__btn">
                <p className="flex-item margin-auto mp-save-bar__btn-text">Save Changes</p>
              </div>
            </div>
          )
        }
      </div>
    </div>
  )
}

export default ManageProfile;